module.exports = __webpack_public_path__ + "static/img/James-Fisher-Harris.b2bd57e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/James-Fisher-Harris.jpg
// module id = AM3F
// module chunks = 0